import axios from "axios";
import { API } from "./api";

const codeApi = axios.create({
  baseURL: `${API}/codes`,
  headers: { "Content-Type": "application/json" },
});

export const startCode = (location, epi_interval_sec = 240) =>
  codeApi.post("", { location, epi_interval_sec }).then((r) => r.data);

export const getCode = (id) => codeApi.get(`/${id}`).then((r) => r.data);

export const updateCodeConfig = (id, payload) =>
  codeApi.patch(`/${id}`, payload).then((r) => r.data);

export const addCodeEvent = (id, payload) =>
  codeApi.post(`/${id}/events`, payload).then((r) => r.data);

export const endCode = (id) => codeApi.post(`/${id}/end`).then((r) => r.data);

export const deleteCodeEvent = (id, eventId) =>
  codeApi.delete(`/${id}/events/${eventId}`).then((r) => r.data);

export const getCodeNarrative = (id) => {
  const tz = Intl?.DateTimeFormat?.().resolvedOptions?.().timeZone || "";
  return codeApi.get(`/${id}/narrative`, { params: tz ? { tz } : {} }).then((r) => r.data);
};
